<div class="modal-overlay">
  <div class="modal-content">
    <div class="modal-header">
      <div class="header-left">
        <img src="assets/trip/trip_logo.svg" class="header-icon" alt="" />
        <h3>Trip Details</h3>
      </div>
      <app-exit-button ariaLabel="Close trip details" (clicked)="onClose()"></app-exit-button>
    </div>

    <div class="modal-body">
      <div class="row">
        <div class="col">
          <div class="label">Underway</div>
          <div class="value large">12h 12m 04s</div>
        </div>
        <div class="col">
          <div class="label">Coordinates</div>
          <div class="value">41°24'12.2"N 2°10'26.5"E</div>
        </div>
      </div>

      <div class="row">
        <div class="col">
          <div class="label">Trip Distance</div>
          <div class="value large">56 mi</div>
        </div>
        <div class="col">
          <div class="label">Average Speed</div>
          <div class="value large">20 mi</div>
          <!-- Should be kts/mph? Image says 20 mi, maybe per hour logic or typo in image, copying image -->
        </div>
      </div>

      <div class="row">
        <div class="col">
          <div class="label">COG</div>
          <div class="value large">245°</div>
        </div>
        <div class="col">
          <div class="label">SOG</div>
          <div class="value large">12.5 kts</div>
        </div>
      </div>

      <div class="row">
        <div class="col">
          <div class="label">Water temp</div>
          <div class="value large">57° F</div>
        </div>
        <div class="col">
          <div class="label">Water depth</div>
          <div class="value large">45 ft</div>
        </div>
      </div>
    </div>

    <div class="modal-footer">
      <button class="action-btn pause">
        <img src="assets/trip/pause_icon.svg" /> Pause
      </button>
      <button class="action-btn lines-in">
        <img src="assets/trip/lines_in.svg" /> Lines In
      </button>
    </div>

  </div>
</div>